<template>
  <div class="home-tool-bar home-tool-bar-large" v-html="toolbar"></div>
</template>
<script>
import { api, session } from "@/assets/js/util.js";
export default {
  name: "ToolBar",
  data() {
    return {
      toolbar: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      let toolbar = session.get("toolbar");
      if (!toolbar === true) {
        api.get("toolbar").then(function(res) {
          if (res.code) {
            session.set("toolbar", res.data.toolbar);
            that.toolbar = session.get("toolbar");
          }
        });
      } else {
        that.toolbar = session.get("toolbar");
      }
    },
  },
};
</script>
<style scoped>
.home-tool-bar {
  position: fixed;
  bottom: 70px;
  right: 0px;
}
</style>
